<template lang="html">
	<entity-page id="page__airportluw" v-bind:loading="progress">
		<template slot="header-right">
            <z-icon-button v-bind:icon="['fa', 'xmark']" danger-light  rounded v-on:click="back"></z-icon-button>
            <z-icon-button v-bind:icon="['fa', 'check']" success-light rounded v-on:click="save"></z-icon-button>
        </template>

		<div class="row">
			<z-select
				label="Тип расчёта" v-model="price.type" :required="true" name="type" id="type" class="col-6"
				v-validate="'required'" v-bind:data-vv-as="' '" v-bind:error="errors.first('type')"
			>
				<option v-bind:value="null" selected disabled>Выбрать...</option>
				<option v-bind:value="1">По весу</option>
				<option v-bind:value="2">По объёму</option>
			</z-select>

			<z-select
				v-bind:label="'Тип расчёта цены по' + (parseInt(price.type) == 2 ? ' объёму' : ' весу')" class="col-6"
				v-model="price.is_min" :required="true" name="is_min" id="is_min"
				v-validate="'required'" v-bind:data-vv-as="' '" v-bind:error="errors.first('is_min')"
			>
				<option v-bind:value="null" selected disabled>Выбрать...</option>
				<option v-bind:value="0">{{ 'За единицу' + (parseInt(price.type) == 2 ? ' объёма' : ' веса')}}</option>
				<option v-bind:value="1">{{ 'За весь' + (parseInt(price.type) == 2 ? ' объём' : ' вес') }}</option>
			</z-select>
		</div>

		<div class="row">
			<z-input
				:label="`Минимальный ${(parseInt(price.type) == 1 ? ' вес' : ' объём')}`"
				v-model="price.value_min" name="value_min" id="value_min" class="col-6" data-vv-name="value_min"
				v-validate="{required: true, min_value: 0.000, max_value: 9999999999, decimal: [3, '.']}"
				v-bind:error="errors.first('value_min')" type="number" v-bind:data-vv-as="' '" required
			></z-input>

			<z-input
				:label="`Максимальный ${(parseInt(price.type) == 1 ? ' вес' : ' объём')}`"
				v-model="price.value_max" name="value_max" id="value_max" class="col-6" data-vv-name="value_max"
				v-validate="{required: true, min_value: 0.000, max_value: 9999999999, decimal: [3, '.']}"
				v-bind:error="errors.first('value_max')" type="number" v-bind:data-vv-as="' '" required
			></z-input>
		</div>

        <z-input
			v-model="price.price" name="price" id="price" label="Цена" type="number"
			v-validate="'required|min_value:0'" v-bind:error="errors.first('price')" v-bind:required="true"
			data-vv-name="price" v-bind:data-vv-as="' '"
		></z-input>
    </entity-page>
</template>
<script>
	import ZInput from '@/components/ZInput';
    import ZSelect from '@/components/ZSelect';
	import EntityPage  from '@/components/EntityPage.vue';
    import ZIconButton from '@/components/ZIconButton';
	import ZInputAutocomplete from '@/components/ZInputAutocomplete';
	export default {
		components: { ZInputAutocomplete, ZInput, ZSelect, ZIconButton, EntityPage },
		data() {
			return {
				price: {},
				priceDefault: {
                    id: null,
                    type: null, // 1 - по весу, 2 - по объёму
					is_min: 0, // 1 - мин, цена, 0 - за ед. веса/объёма
                    price: 0,
                    value_min: null,
                    value_max: null,
				},
                types: {
                    1: {
                        name: 'По весу',
                        value: 1,
                    },
                    2: {
                        name: 'По объёму',
                        value: 2,
                    }                   
                }                
			}
		},
		computed: {
			/**
             * Флаг загрузки текущего компонента
             */
			progress() {
				return this.progressObj['load-price-card'];
			},
			/**
             * Объект с флагами загрузки
             */
			progressObj() {
				return this.$store.state.progressObj;
			}
		},
		watch: {
			'$route.params.id'() {
				this.init();
			}
		},
		methods: {
			/**
             * Инициализация компонента
             */
			init() {
				this.$store.commit('openRightPanel');
				if (this.$route.params.id !== 'new') this.getPrice();
				else this.price = Object.assign({}, this.priceDefault);
			},
			/**
			 * Получение ценгы
			 */
			getPrice() {
				this.$store.commit('showProgressBar', 'load-price-card');
				return this.$store.dispatch('cost/getAirportLuw', this.$route.params.id).then(r => {
					this.price = Object.assign({}, r);
					return this.price;
				}).finally(() => this.$store.commit('hideProgressBar', 'load-price-card'));
			},
			/**
			 * Сохранение
			 */
			save() {
				this.$validator.validateAll().then(valid => {
					if (!valid) return;
					if (this.$route.params.id != 'new') this.putPrice();
                    else this.postPrice();
				});
			},
			/**
			 * Добавление цены
			 */
			postPrice() {
                this.$validator.validateAll().then(valid => {
                    if (!valid) return;
                    this.$store.commit('showProgressBar', 'load-price-card');
                    this.$store.dispatch('cost/postAirportLuw', this.price).then(r => {
                        this.$root.$emit('reload-table', 'airportluws');
                        this.$router.replace({name: 'AirportLuwPrice', params: {id: r.id}});
                    }).finally(() => this.$store.commit('hideProgressBar', 'load-price-card'));
                });
			},
			/**
			 * Изменение цены
			 */
			putPrice() {
                this.$validator.validateAll().then(valid => {
                    if (!valid) return;
                    this.$store.commit('showProgressBar', 'load-price-card');
                    this.$store.dispatch('cost/putAirportLuw', this.price).then(r => {
                        if (!r) return;
                        this.init();
                        this.$root.$emit('reload-table', 'airportluws');
                    }).finally(() => this.$store.commit('hideProgressBar', 'load-price-card'));
                });
			},            
			/**
             *Возвращает пользователя на предыдущую страницу
            * Обрабочик события click, на кнопке "Закрыть" 
            */
			back() {
                this.$router.push({name: 'AirportLuwPrices', query: this.$route.query});
            }
		},
		created() {
			this.init();
		}		
	}
</script>


// WEBPACK FOOTER //
// AirportLuw.vue?5d347e44